module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 42
// module chunks = 1